export interface IRecordPageEdit {
    hasSheet: boolean;
}

export class RecordPageEdit implements IRecordPageEdit {
    hasSheet: boolean;

    constructor();
    constructor(obj: IRecordPageEdit);
    constructor(obj?: any) {
        this.hasSheet = obj && obj.hasSheet || false;
    }
}